<template>
  <div class="summary-detail-container" @scroll="handelScroll">
    <div class="affix" :class="{sticky:sticky}">
      <h2 v-if="layout==='NORMAL'">
        <span style="font-size: 2rem">{{ name }}</span>
        {{ type }}详情
        <template v-if="organization_name">
          <span class="active">{{ organization_name }}</span>
          /
        </template>
        <span class="active">{{ year }}年<template v-if="month">{{ month }}月</template></span>
        投广数据

        <el-popover
            v-if="customerId"
            placement="right"
            width="300"
            trigger="click">
        <div class="default-table">
          <el-table :data="dataList" height="200" v-loading="customerLoad">
            <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
                width="55">
            </el-table-column>
            <el-table-column
                prop="customer_name"
                label="客户名称"
                align="center"
                header-align="center"
                width="220">
            </el-table-column>
          </el-table>
        </div>
          <template slot="reference">
            <div class="tag_span">
              <b v-if="keyCustomerId&&keyCustomerId>0">【<span class="active">重点客户</span>】</b>
              <span>其中包括多个客户：
                    <i @click="getList" class="el-icon-s-custom"></i></span>
            </div>
          </template>
        </el-popover>

        <el-date-picker
            style="float: right;margin-right: 20px"
            :clearable="true" v-model="year"
            value-format="yyyy"
            format="yyyy年"
            type="year"
            placeholder="选择月份" @change="selectedYear"/>
      </h2>
      <h2 v-else>
        <span class="active">
          <span>{{ year }}</span>年
          <span>{{ month }}</span>月
        </span>
        统计
        <template v-if="organization_name">
          <span class="active">{{ organization_name }}</span>
        </template>
        <span v-html="type"/>
        <slot name="append"/>
      </h2>
    </div>
    <div style="padding: 12px;">
      <slot/>

    </div>
  </div>
</template>

<script>
import {detail} from "@/api/organization";
import {lsGet} from "@/utils";
import {getProfileCustomerInfo} from "@/api/profileCustomer";
import {getKeyCustomerRelCustomers} from "@/api/profileCustomer";

export default {
  name: "SummaryDetail",
  props: {
    //是否限制范围
    isScope:{
      type:Boolean,
      default() {
        return false;
      }
    },
    keyCustomerId: {
      type: [Number, String],
      default: 0
    },
    name: [Number, String],
    type: [Number, String],
    year: [Number, String],
    month: [Number, String],
    layout: {
      type: [Number, String],
      default() {
        return 'NORMAL'
      }
    },
  },
  data() {
    return {
      sticky: false,
      organization_name: null,
      customerId: null,
      dataList: [],
      customerLoad: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const {keyCustomerId} = this.$route.query
      this.customerId = keyCustomerId ? keyCustomerId : null
      // getProfileCustomerInfo
      this.middleware()
    },
    async getList() {
      this.dataList = []
      if (this.customerId) {
        this.customerLoad = true
        //限制范围，即销售进入该页面触发
        if(this.isScope){
          let {data: {list}} = await getKeyCustomerRelCustomers({key_customer_id: this.customerId})
          this.dataList = list || []
        }else {
          const {data} = await getProfileCustomerInfo({id: this.customerId})
          this.dataList = data.info.items || []
        }
        // this.formData = data.info.items || []
        this.customerLoad = false
      }
    },
    middleware() {
      const {can_see_all_summary} = lsGet('userAuth')
      const {organization_name} = lsGet('user')
      if (!can_see_all_summary) {
        // 固定小组 从缓存得到小组名称
        this.organization_name = organization_name
      } else {
        this.getOrg()
      }
    },
    handelScroll(e) {
      this.sticky = e.target.scrollTop > 64
    },
    async getOrg() {
      const {organization_id} = this.$route.query
      if (!organization_id) {
        return;
      }
      const {model} = await detail({id: organization_id})
      this.organization_name = model && model.name ? model.name : null
    },
    selectedYear(year) {
      const {name, query} = this.$route
      query.year = year
      const {href} = this.$router.resolve({name, query});
      location.href = href
    }
  }
}
</script>

<style lang="scss" scoped>
.summary-detail-container {
  font-family: FjallaOne-Regular, sans-serif !important;
  overflow-x: hidden;
  height: 100%;
  overflow-y: auto;

  h2 {
    padding-left: 20px;
  }

  .sticky {
    text-align: center;
    width: 100%;
    padding: 0 20px;
    position: fixed;
    top: 64px;
    background: #fff;
    z-index: 98;
    box-shadow: 0 2px 10px 0 rgba(201, 205, 214, .5);

    h2 {
      text-align: center !important;
    }
  }

  .active {
    color: #E03F3D;

    span {
      font-size: 1.25em;
    }
  }

  .el-icon-s-custom {
    font-size: 18px;
    color: #E03F3D;
    //margin-left: 10px;
  }

  .tag_span {
    display: inline-block;
    cursor: pointer;

    > span {
      color: #909399;
      margin-left: 2px;
      font-size: 12px;
    }

    > b {
      font-family: FjallaOne-Regular, sans-serif !important;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>
